import {createEntityAdapter} from '@reduxjs/toolkit';
/** @namespace Accounting.Adapters */

/**
 * Creates an entity adapter for the breakdown data.
 *
 * @param {object} options - The options for the entity adapter.
 * @param {function} options.selectId - A function that returns the ID of the entity.
 * @returns {object} - The entity adapter instance.
 *
 * @example
 * const breakdownDataAdapter = createEntityAdapter({
 *     selectId: facilityData => facilityData.facilityId,
 * });
 */
export const breakdownDataAdapter = createEntityAdapter({
    selectId: (facilityData) => facilityData.facilityId,
});
